// extracted by mini-css-extract-plugin
export default {"wrapper":"PreloaderViolentCrimeRiskGraph_wrapper__08Khv","graph":"PreloaderViolentCrimeRiskGraph_graph__qZJqM"};